const e = "FareInfographic-module_container__zvoIF",
  a = "FareInfographic-module_groups__B-rJl",
  o = "FareInfographic-module_separator__F62E8",
  r = "FareInfographic-module_group__eboF8",
  s = "FareInfographic-module_disabled__V1MiH",
  i = "FareInfographic-module_step-footnote__MT8Ir",
  n = "FareInfographic-module_group-header-icon__mVNOS",
  t = "FareInfographic-module_group-header__aZmUz",
  _ = "FareInfographic-module_group-header-underline__rZLX4",
  p = "FareInfographic-module_variant-default__DRUzm",
  l = "FareInfographic-module_isCollapsed__tfihY",
  c = "FareInfographic-module_steps__X1mmF",
  d = "FareInfographic-module_separator-disabled__PDaze",
  u = "FareInfographic-module_isExpanded__muKG1",
  g = "FareInfographic-module_is-pre-cruise__5hX-Z",
  h = "FareInfographic-module_is-post-cruise__iaUlr",
  F = "FareInfographic-module_variant-full-horizontal__5DL7h",
  f = "FareInfographic-module_is-shorex__GN8px",
  m = "FareInfographic-module_variant-always-vertical__bzTHa",
  I = {
    container: e,
    groups: a,
    separator: o,
    group: r,
    disabled: s,
    stepFootnote: i,
    groupHeaderIcon: n,
    groupHeader: t,
    groupHeaderUnderline: _,
    static: "FareInfographic-module_static__NUIBA",
    variantDefault: p,
    isCollapsed: l,
    steps: c,
    separatorDisabled: d,
    isExpanded: u,
    isPreCruise: g,
    isPostCruise: h,
    variantFullHorizontal: F,
    isShorex: f,
    variantAlwaysVertical: m
  };
export { I as s };